import React from 'react'

import {
  AlignItems,
  Box,
  Color,
  Display,
  FlexDirection,
  FontWeight,
  Image,
  JustifyContent,
  Paragraph,
  Space,
  Text,
  TextAlign,
} from '@gousto-internal/citrus-react'

import JoeWicksImage from 'routes/Home/JoeWicks/assets/joe-wicks.jpg'
import { joeWicks } from 'routes/Home/homeConfig'

export const JoeWicks = () => (
  <Box bg={Color.ColdGrey_800} display={Display.Flex} justifyContent={JustifyContent.Center}>
    <Box
      alignItems={AlignItems.Center}
      paddingV={[12, 8]}
      paddingH={[4, 8]}
      display={Display.Flex}
      flexDirection={[FlexDirection.Column, FlexDirection.Row]}
      maxWidth="75rem"
      data-testid="JoeWicks"
    >
      <Box width="100%" maxWidth="22rem" paddingRight={[0, 8, 8, 20]} paddingBottom={[8, 0]}>
        <Image
          width="100%"
          height="auto"
          minWidth={[null, '11rem']}
          src={JoeWicksImage}
          alt="Joe Wicks holding a Gousto dish"
        />
      </Box>
      <Box
        display={Display.Flex}
        flexDirection={FlexDirection.Column}
        alignItems={[AlignItems.Center, AlignItems.FlexStart]}
      >
        <Paragraph
          textAlign={[TextAlign.Center, TextAlign.Left]}
          size={[4, 5]}
          fontWeight={FontWeight.Bold}
          color={Color.White}
        >
          {joeWicks}
        </Paragraph>
        <Space size={[4]} />
        <Box display={Display.Flex} alignItems={AlignItems.Center}>
          <Text size={3} fontWeight={FontWeight.Bold} style={{ color: '#bbc2ff' }}>
            Joe Wicks
          </Text>
          <Text size={2} color={Color.White}>
            &nbsp;| The Body Coach
          </Text>
        </Box>
      </Box>
    </Box>
  </Box>
)
